export var OfferingLocationType;
(function (OfferingLocationType) {
    OfferingLocationType["CUSTOMER"] = "CUSTOMER";
    OfferingLocationType["BUSINESS"] = "BUSINESS";
    OfferingLocationType["OTHER"] = "OTHER";
})(OfferingLocationType || (OfferingLocationType = {}));
export var ServiceLocationType;
(function (ServiceLocationType) {
    ServiceLocationType["OWNER_BUSINESS"] = "OWNER_BUSINESS";
    ServiceLocationType["CLIENT_PLACE"] = "CLIENT_PLACE";
    ServiceLocationType["OWNER_CUSTOM"] = "OWNER_CUSTOM";
})(ServiceLocationType || (ServiceLocationType = {}));
//# sourceMappingURL=offering-location.dto.js.map